import controller from './related.controller';
import template from './related.template.html';
import './related.scss';

export default {
  template,
  controller,
  bindings: {
    title: '@',
    relatedList: '<',
    showMore: '<?',
    takeOnly: '<?',
    onClickMore: '&?',
    onClickItem: '&?',
  },
};



// WEBPACK FOOTER //
// ./src/app/shared/related/related.component.js